<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class NumericTextBoxClearButtonMixin extends Vue {
  onTextBoxCreated() {
    const numericTextBox: any = this.$refs.numericTextBox
    if (numericTextBox) {
      numericTextBox.$el.addEventListener('mouseover', this.showClearButton)
      numericTextBox.$el.addEventListener('mouseout', this.hideClearButton)
    }
  }

  onTextBoxDestroyed() {
    const numericTextBox: any = this.$refs.numericTextBox
    if (numericTextBox) {
      numericTextBox.$el.removeEventListener('mouseover', this.showClearButton)
      numericTextBox.$el.removeEventListener('mouseout', this.hideClearButton)
    }
  }

  showClearButton() {
    const numericTextBox: any = this.$refs.numericTextBox
    if (numericTextBox) {
      const clearButton = numericTextBox.$el.parentNode.querySelector('.e-clear-icon')
      if (clearButton.classList.contains('e-clear-icon-hide') && numericTextBox.value) {
        clearButton.classList.remove('e-clear-icon-hide')
      }
    }
  }

  hideClearButton(event: MouseEvent) {
    const numericTextBox: any = this.$refs.numericTextBox
    if (numericTextBox) {
      const clearButton = numericTextBox.$el.parentNode.querySelector('.e-clear-icon')
      const isTarget: boolean = event.relatedTarget === clearButton
      if (!clearButton.classList.contains('e-clear-icon-hide') && !isTarget) {
        clearButton.classList.add('e-clear-icon-hide')
      }
    }
  }
}
</script>
